// a context that will exist on my admin dashboard and my app and will tell my copy pasted components how to behave each 

import { createContext, useContext } from "react";

const EnvContext = createContext();


export const EnvProvider = ({ children }) => {
  const value = {
    showThumbnails: false,
  }

  return <EnvContext.Provider value={value}>{children}</EnvContext.Provider>;
};

export const useEnv = () => useContext(EnvContext);

export default EnvContext;

